export const heroStats = [
  { value: '12,800+', label: '已收录资源索引' },
  { value: '36', label: '全量分类维度' },
  { value: '365 天', label: '持续更新汇总' },
];

export const categoryIndex = [
  { name: '热点聚合', count: 128, icon: 'ri-fire-line' },
  { name: '资源合集', count: 96, icon: 'ri-folder-2-line' },
  { name: '分类大全', count: 214, icon: 'ri-layout-grid-line' },
  { name: '榜单速览', count: 48, icon: 'ri-bar-chart-2-line' },
  { name: '每日更新', count: 365, icon: 'ri-calendar-check-line' },
  { name: '专题汇总', count: 72, icon: 'ri-bookmark-3-line' },
  { name: '索引归档', count: 156, icon: 'ri-archive-line' },
  { name: '完整导航', count: 320, icon: 'ri-compass-3-line' },
];

export const rankingHighlight = {
  rank: 1,
  title: '本周资源合集聚合总览',
  category: '资源合集',
  desc: '把本周新增与历史合集重新编排，按主题归入同一索引页，方便一次性浏览完整清单。',
  heat: 9860,
  collect: 1280,
  updated: '今日 14:20 更新',
  image:
    'https://readdy.ai/api/search-image?query=Stylized%20minimal%20pedestal%20with%20an%20ascending%20bar%20chart%20built%20from%20stacked%20paper%20blocks%20in%20warm%20terracotta%20amber%20and%20clay%20tones%20on%20a%20cream%20background%2C%20soft%20directional%20shadows%2C%20editorial%20illustration%20style%2C%20generous%20negative%20space%2C%20clean%20consistent%20warm%20neutral%20backdrop%2C%20high%20detail%2C%20refined%20composition&width=800&height=600&seq=blackliao-rank-01&orientation=landscape',
};

export const hotRanking = [
  { rank: 1, title: '本周资源合集聚合总览', category: '资源合集', heat: 9860, trend: 'up', change: 12 },
  { rank: 2, title: '全量分类索引快速导航', category: '完整导航', heat: 8720, trend: 'up', change: 8 },
  { rank: 3, title: '热门内容分类汇总', category: '分类大全', heat: 8140, trend: 'flat', change: 0 },
  { rank: 4, title: '每日更新内容一览', category: '每日更新', heat: 7630, trend: 'down', change: 4 },
  { rank: 5, title: '历史专题归档速览', category: '专题汇总', heat: 6980, trend: 'up', change: 5 },
  { rank: 6, title: '全站资源检索入口', category: '索引归档', heat: 6420, trend: 'flat', change: 0 },
];

export const featuredCollections = [
  {
    title: '内容分类大全',
    tag: '分类大全',
    count: 214,
    updated: '今日更新',
    desc: '按主题拆分的完整分类目录，从热点到冷门一页铺开，浏览路径清晰。',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20flat-lay%20of%20neatly%20stacked%20archive%20folders%2C%20index%20cards%20and%20small%20paper%20tabs%20arranged%20on%20a%20warm%20oatmeal%20surface%2C%20soft%20diffused%20daylight%2C%20muted%20clay%20sand%20and%20ivory%20tones%2C%20generous%20negative%20space%2C%20clean%20consistent%20neutral%20background%2C%20refined%20magazine%20styling%2C%20high%20detail%2C%20harmonious%20warm%20palette&width=1000&height=750&seq=blackliao-card-01&orientation=landscape',
  },
  {
    title: '资源合集导航',
    tag: '资源合集',
    count: 96,
    updated: '昨日更新',
    desc: '把零散条目整理成可复用的合集清单，按维度分组，随取随看。',
    image:
      'https://readdy.ai/api/search-image?query=Top-down%20minimal%20photograph%20of%20categorized%20card%20tabs%2C%20paper%20bookmarks%20and%20labeled%20dividers%20laid%20out%20in%20a%20tidy%20grid%20on%20warm%20cream%20paper%2C%20soft%20natural%20light%2C%20muted%20terracotta%20and%20olive%20accents%2C%20generous%20negative%20space%2C%20clean%20consistent%20warm%20neutral%20backdrop%2C%20editorial%20styling%2C%20high%20detail&width=1000&height=750&seq=blackliao-card-02&orientation=landscape',
  },
  {
    title: '每日汇总清单',
    tag: '每日更新',
    count: 365,
    updated: '刚刚更新',
    desc: '每天固定时段汇总当天新增内容，索引条目按时间排列，回顾更省心。',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20still%20life%20of%20an%20open%20notebook%20with%20a%20handwritten%20index%20list%20beside%20a%20wooden%20pencil%20and%20small%20paper%20clips%20on%20a%20warm%20beige%20desk%2C%20soft%20window%20light%2C%20muted%20sand%20and%20clay%20tones%2C%20generous%20negative%20space%2C%20clean%20consistent%20neutral%20background%2C%20refined%20composition%2C%20high%20detail&width=1000&height=750&seq=blackliao-card-03&orientation=landscape',
  },
  {
    title: '专题归档速览',
    tag: '专题汇总',
    count: 72,
    updated: '本周更新',
    desc: '过往专题统一归档，按周期与热度排出优先顺序，适合系统回看。',
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20flat-lay%20of%20stacked%20paper%20trays%20with%20labeled%20dividers%20and%20loose%20index%20sheets%20on%20a%20warm%20ivory%20surface%2C%20soft%20diffused%20light%2C%20muted%20amber%20clay%20and%20stone%20tones%2C%20generous%20negative%20space%2C%20clean%20consistent%20warm%20neutral%20backdrop%2C%20refined%20magazine%20aesthetic%2C%20high%20detail&width=1000&height=750&seq=blackliao-card-04&orientation=landscape',
  },
];

export const categoryGroups = [
  {
    name: '内容聚合',
    desc: '把分散的热点与话题收进同一入口',
    count: 128,
    items: ['热点聚合', '专题汇总', '实时索引', '话题归档', '热榜速览'],
  },
  {
    name: '资源合集',
    desc: '按维度整理成可直接浏览的合集',
    count: 96,
    items: ['合集总览', '精选清单', '连载整理', '系列归档', '资源导航'],
  },
  {
    name: '分类大全',
    desc: '完整分类目录，按主题逐层展开',
    count: 214,
    items: ['主题分类', '区域分类', '时间分类', '类型分类', '标签大全'],
  },
  {
    name: '索引归档',
    desc: '历史条目统一归档，随时回看',
    count: 156,
    items: ['月度归档', '季度归档', '年度汇总', '历史检索', '索引备份'],
  },
  {
    name: '榜单速览',
    desc: '以热度与更新频率排出的快照',
    count: 48,
    items: ['热度榜', '更新榜', '收藏榜', '浏览榜', '口碑榜'],
  },
  {
    name: '完整导航',
    desc: '全站入口集中展示，一站直达',
    count: 320,
    items: ['板块导航', '字母索引', '标签云', '分类地图', '快捷入口'],
  },
];

export const latestUpdates = [
  { time: '09-11 14:20', title: '新增「秋季专题」资源合集条目', category: '专题汇总' },
  { time: '09-11 09:05', title: '更新分类大全中的主题分类索引', category: '分类大全' },
  { time: '09-10 21:40', title: '补齐索引归档的月度汇总清单', category: '索引归档' },
  { time: '09-10 16:12', title: '热度榜重排，前六位顺序调整', category: '榜单速览' },
  { time: '09-10 10:30', title: '新增三个内容聚合入口与对应导航', category: '内容聚合' },
  { time: '09-09 19:48', title: '全站检索入口优化，缩短查找路径', category: '完整导航' },
];

export const faqs = [
  {
    q: '黑料总站主要汇总哪些内容？',
    a: '首页以导航与索引为主，把各类资源合集、分类大全、专题汇总集中展示，方便按分类快速浏览，一站获取完整资源导航。',
  },
  {
    q: '如何按分类快速查找？',
    a: '可以先在首屏的搜索框输入关键词，也可以直接使用分类索引条，点击对应分类即可跳转到页面内的汇总区块。',
  },
  {
    q: '热度榜多久更新一次？',
    a: '热度榜依据浏览与收藏综合排序，通常每日更新一次；遇到热点集中时会临时重排，保证排序贴合当下关注。',
  },
  {
    q: '更新动态里的条目会保留吗？',
    a: '会。新条目会先出现在更新动态中，之后统一归入索引归档，历史清单可随时回看。',
  },
];

export const footerGroups = [
  {
    title: '分类索引',
    links: ['热点聚合', '资源合集', '分类大全', '榜单速览'],
  },
  {
    title: '资源导航',
    links: ['每日更新', '专题汇总', '索引归档', '完整导航'],
  },
  {
    title: '关于本站',
    links: ['站内说明', '更新节奏', '使用帮助', '常见问题'],
  },
];